(function ($) {
  window.LabelList = function (container) {
    container = jQuery(container);
    var labelTemplate = container.data("label-template");

    // HELPER FUNCTIONS

    function toggleLabel(labelJSON) {
      if (findLabel(labelJSON.id).length) {
        removeLabel(labelJSON);
      } else {
        addLabel(labelJSON);
      }
    }

    function addLabel(labelJSON) {
      if (!findLabel(labelJSON.id).length) {
        var result = labelFromJSON(labelJSON).appendTo(container).before(" ");
        container.trigger("labelAdded", labelJSON);
        return result;
      }
    }

    function removeLabel(labelJSON) {
      return findLabel(labelJSON.id).remove();
    }

    function findLabel(labelId) {
      return labels().filter('[data-label-id="' + labelId + '"]');
    }

    function labels() {
      return container.find("[data-label-id]");
    }

    function labelFromJSON(labelJSON) {
      var html = String(labelTemplate);
      html = html.replace(/TEXT_COLOR/g, labelJSON.text_color);
      html = html.replace(/COLOR/g, labelJSON.color);
      html = html.replace(/ID/g, labelJSON.id);
      html = html.replace(/NAME/g, labelJSON.name);
      var label = jQuery(html);
      label[0].classList.toggle("--dark", Boolean(labelJSON.dark));

      return label;
    }

    function labelToJSON(labelElement) {
      return {
        color: jQuery(labelElement).css("background-color"),
        textColor: jQuery(labelElement).css("color"),
        id: jQuery(labelElement).data("label-id"),
        name: jQuery(labelElement).text(),
        dark: domElement(labelElement).classList.contains("--dark"),
      };
    }

    function domElement(labelElement) {
      return labelElement.jquery ? labelElement[0] : labelElement;
    }

    // PUBLIC INTERFACE

    jQuery.extend(this, {
      labels: labels,
      labelJSON: labelToJSON,
      toggleLabel: toggleLabel,
      addLabel: addLabel,
      removeLabel: removeLabel,
    });
  };
})(jQuery);
